import { Attachment, getAttachmentMeta } from "@/data/attachments";

const isPromise = <T>(value: T | Promise<T>): value is Promise<T> => {
  return Boolean(value) && typeof (value as Promise<T>).then === "function";
};

export const imageResolver = (systemId: string) => {
  const attachmentMetaResult = getAttachmentMeta({ systemId }) as Promise<Attachment> | Attachment;

  if (isPromise(attachmentMetaResult)) {
    return attachmentMetaResult.then(data => data.publicUrl || "");
  }

  return Promise.resolve(attachmentMetaResult.publicUrl || "");
};
